import React from 'react';
import { Label } from '../ui/label';
import { Checkbox } from '../ui/checkbox';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';

const ADDITIONAL_ITEMS = [
  'Chip bags / snack wrappers', 'Candy bar wrappers', 'Water bottle wraps', 'Favor tags',
  'Stickers', 'Signage / posters', 'Activity sheets or games', 'Other',
];

export const BundleItemsSection = ({ formData, set, orderData, showSizingInfo, needsFavorChoice, onItemToggle, children }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 5: BUNDLE ITEMS CONFIRMATION</h3>

    <div className="bg-soft-linen p-6 rounded-lg border border-stone-taupe/20">
      <h4 className="text-lg font-semibold text-charcoal-ink mb-2">Included with Your Bundle</h4>
      <p className="text-stone-taupe mb-4">The items listed below are included with your selected bundle. Please review carefully.</p>

      {orderData?.items && (
        <div className="space-y-4">
          {orderData.items.map((item) => (
            <div key={item.id} className="bg-white p-4 rounded-lg">
              <div className="flex items-start gap-3 mb-3">
                <img src={item.image} alt={item.name} className="w-16 h-16 object-cover rounded" />
                <div>
                  <p className="font-semibold text-charcoal-ink">{item.name}</p>
                  <p className="text-sm text-stone-taupe capitalize">{item.priceType}</p>
                </div>
              </div>
              <div className="space-y-1">
                {item.includes && item.includes.map((includedItem, idx) => (
                  <div key={idx} className="flex items-start gap-2">
                    <span className="text-charcoal-ink">•</span>
                    <span className="text-charcoal-ink text-sm">{includedItem}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}

      <p className="text-stone-taupe mt-4 text-sm">If you'd like to request additional items, you may note them below. Additional fees may apply.</p>
    </div>

    {showSizingInfo && (
      <div className="bg-warm-ivory border border-stone-taupe/20 p-5 rounded-lg" data-testid="standard-sizing-info">
        <h4 className="font-semibold text-charcoal-ink mb-2">Standard Item Sizing</h4>
        <ul className="space-y-1 text-sm text-charcoal-ink">
          <li>• Chip bag designs are created in standard 8.5x11 format.</li>
          <li>• Candy wrappers are designed to fit standard 1.55 oz Hershey bars.</li>
        </ul>
      </div>
    )}

    {needsFavorChoice && (
      <div data-testid="favor-item-choice">
        <Label className="text-charcoal-ink mb-3 block">Please select one included favor item: *</Label>
        <RadioGroup value={formData.favorItemChoice} onValueChange={(value) => set('favorItemChoice', value)}>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="chip-bag" id="favor-chip-bag" />
            <Label htmlFor="favor-chip-bag" className="text-charcoal-ink font-normal cursor-pointer">Chip Bag Design</Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="candy-wrapper" id="favor-candy-wrapper" />
            <Label htmlFor="favor-candy-wrapper" className="text-charcoal-ink font-normal cursor-pointer">Candy Wrapper Design</Label>
          </div>
        </RadioGroup>
      </div>
    )}

    <div>
      <Label className="text-charcoal-ink mb-3 block">Additional Items Requested (optional)</Label>
      <div className="space-y-3">
        {ADDITIONAL_ITEMS.map((item) => (
          <div key={item} className="flex items-center space-x-2">
            <Checkbox
              id={item}
              checked={formData.bundleItems.includes(item)}
              onCheckedChange={() => onItemToggle(item)}
            />
            <Label htmlFor={item} className="text-charcoal-ink font-normal cursor-pointer">{item}</Label>
          </div>
        ))}
      </div>
    </div>

    {children}
  </div>
);
